import { render, staticRenderFns } from "./physioParallelCombination.vue?vue&type=template&id=65c91ac5&scoped=true"
import script from "./physioParallelCombination.vue?vue&type=script&lang=js"
export * from "./physioParallelCombination.vue?vue&type=script&lang=js"
import style0 from "./physioParallelCombination.vue?vue&type=style&index=0&id=65c91ac5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c91ac5",
  null
  
)

export default component.exports